/**
 * Converts string into an int
 *
 * @param param - a string to convert into a number
 * @returns converted path param
 */
export default function parsePathParamToInt(param?: string | string[]): number | null {
  if (!param) {
    return null;
  }

  if (Array.isArray(param)) {
    return null;
  }

  const integer = parseInt(param, 10);

  if (Number.isNaN(integer)) {
    return null;
  }

  return integer;
}
